import React from 'react';
import { Link } from 'react-router-dom';
import './Website.css';

export default function UpgradeSuccess() {
  return (
    <main className="site-page utility-page centered-page">
      <section className="result-card">
        <span className="result-mark">✓</span>
        <p className="eyebrow">Upgrade complete</p>
        <h1>Your Powerhouse plan is active.</h1>
        <p>
          Open the Unsubscriber extension with the same Gmail account to start using your premium scans.
        </p>
        <Link className="button button-primary" to="/">Return home</Link>
      </section>
    </main>
  );
}
